/**
 * Public legal-page route paths, hosted by the web app. Single source of truth shared by the
 * web router, the in-app footer, the pay app's consent links, and email links so a path rename
 * happens in one place.
 */
export const LEGAL_ROUTES = {
  termsOfUse: '/terms-of-use',
  privacyPolicy: '/privacy-policy'
} as const;
